import { Icon } from "@outschool/backpack";
import { IconDefinition } from "@outschool/icons";
import {
  TrackedButton,
  TrackedButtonProps
} from "@outschool/ui-components-shared";
import React, { ReactNode } from "react";

type Props = TrackedButtonProps & {
  icon?: IconDefinition;
  isSelected?: boolean;
  children: ReactNode;
};

export const SquareButton = ({
  icon,
  isSelected,
  children,
  ...buttonProps
}: Props) => {
  return (
    <TrackedButton
      {...buttonProps}
      sx={{
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "neutral.light",
        padding: "16px",
        justifyContent: "start",
        gap: "16px",
        color: isSelected ? "primary.main" : "grey.900",
        backgroundColor: isSelected ? "primary.50" : undefined,
        height: "112px",
        minWidth: "fit-content",
        ...buttonProps.sx
      }}
    >
      {icon && (
        <Icon
          icon={icon}
          fixedWidth
          sx={{
            fontSize: "32px",
            margin: "3px 0"
          }}
        />
      )}
      {children}
    </TrackedButton>
  );
};
